import React from 'react';
export function PackComposite() {
  return <section className="py-16 px-4 bg-[#FFF8F0]" data-id="element-74">
      <div className="max-w-5xl mx-auto text-center" data-id="element-75">
        <h2 className="text-2xl md:text-3xl font-bold text-[#3C1518] mb-12" data-id="element-76">
          Todo este contenido está incluido hoy en el mismo pack.
        </h2>

        <div className="relative w-full max-w-4xl mx-auto h-[400px] md:h-[500px] flex items-center justify-center mb-12" data-id="element-77">
          {/* Glow effect behind */}
          <div className="absolute inset-0 bg-[#EA580C]/10 blur-3xl rounded-full" data-id="element-78" />

          {/* Main Book - Center */}
          <img src="https://cdn.magicpatterns.com/uploads/pjNYPMa38ZXenkpPoKnA5F/0_cover_1.png" alt="Main Product" className="absolute z-30 h-[80%] md:h-[90%] object-contain drop-shadow-2xl" data-id="element-79" />

          {/* Bonus 1 - Left */}
          <img src="https://cdn.magicpatterns.com/uploads/t8fgheMQai3NxcKNz6Y6an/bono_1.png" alt="Bonus 1" className="absolute z-20 h-[60%] md:h-[70%] object-contain -translate-x-[40%] md:-translate-x-[60%] -rotate-6 drop-shadow-xl opacity-90" data-id="element-80" />

          {/* Bonus 2 - Right */}
          <img src="https://cdn.magicpatterns.com/uploads/dKoPSCRCnvvLVAhiYVtAa9/bono_2.png" alt="Bonus 2" className="absolute z-20 h-[60%] md:h-[70%] object-contain translate-x-[40%] md:translate-x-[60%] rotate-6 drop-shadow-xl opacity-90" data-id="element-81" />

          {/* Bonus 4 - Far Right/Back */}
          <img src="https://cdn.magicpatterns.com/uploads/fLQ9R9S39YUdvCpkZwNgTr/bono_4.png" alt="Bonus 4" className="absolute z-10 h-[50%] md:h-[60%] object-contain translate-x-[80%] md:translate-x-[100%] rotate-12 drop-shadow-lg opacity-80 hidden md:block" data-id="element-82" />
        </div>

        <p className="text-xl text-[#5C2D0E] max-w-2xl mx-auto" data-id="element-83">
          Si compraras cada uno de estos recetarios por separado, el valor sería
          mucho mayor.
          <br data-id="element-84" />
          <br data-id="element-85" />
          <span className="text-[#C2410C] font-bold" data-id="element-86">
            Pero hoy podés acceder a todo el pack completo por un precio
            especial.
          </span>
        </p>
      </div>
    </section>;
}